import CutwiseAPIClient, { METHOD_GET, METHOD_POST } from '@/common/network/CutwiseAPIClient';
export const PATH_CUSTOMGRADE = 'api/v2/customgrade';
export default class CustomGradingAPI {
    fetchCustomGradeAttribute(attribute) {
        const qb = CutwiseAPIClient.createQueryBuilder()
            .method(METHOD_GET)
            .path(`${PATH_CUSTOMGRADE}/attribute/${attribute}`);
        const query = qb.getQuery();
        return CutwiseAPIClient.sendQuery(query);
    }
    fetchCustomGradingDataForProducts(products, gradingFieldKey) {
        const qb = CutwiseAPIClient.createQueryBuilder()
            .method(METHOD_GET)
            .path(PATH_CUSTOMGRADE)
            .addQueryStringParam('product', products.map((p) => p.id))
            .addQueryStringParam('attribute', gradingFieldKey);
        const query = qb.getQuery();
        return CutwiseAPIClient.sendQuery(query);
    }
    changeCustomGradeForProduct(product, resultedGrade, gradingFieldKey, lastProductPosition, sessionId) {
        const qb = CutwiseAPIClient.createQueryBuilder()
            .method(METHOD_POST)
            .path(PATH_CUSTOMGRADE)
            .body({
            attribute: gradingFieldKey,
            product: product.id,
            grade: {
                grade: resultedGrade.id,
                session: sessionId,
                initialPosition: lastProductPosition,
            },
        });
        const query = qb.getQuery();
        return CutwiseAPIClient.sendQuery(query);
    }
}
